import React, { useState, useEffect } from 'react';
import './CreateProjectPage.css';
import SelectDirectoryComponent from './SelectDirectoryComponent';
import SelectTenantNInspection from './SelectTenantNInspection';
import { axiosPrivate } from '../api/axios';
import { TextInput, Button, Stack } from '@mantine/core';
import { useForm } from '@mantine/form';
import { notifications } from '@dronebase/shared-ui-core';

function CreateProjectPage() {
    const [directories, setDirectories] = useState([]);
    const [selectedDirectory, setSelectedDirectory] = useState('');
    const [selectedTenantInspection, setSelectedTenantInspection] = useState({});
    const form = useForm({
        initialValues: {
            projectName: '',
            projectDescription: '',
            directory: '',
            blobId: '',
            tenant: '',
            inspections: [],
        },
    });

    useEffect(() => {
      if (directories.length > 0) {
        return;
      }
      
      const fetchDirectories = async () => {
        const fetched = await axiosPrivate.get('api/getBlobs');
        console.log('in parent', fetched.data);
        setDirectories(fetched.data);
      }
      try {
        fetchDirectories();
      } catch (error) {
        console.log('error fetching directories', error);
      }
    }, [directories]);

    const storedAuth = JSON.parse(sessionStorage.getItem("aimauth"));
    const accessToken = storedAuth?.accessToken;

    const resetForm = () => {
      form.reset();
      setSelectedDirectory('');
      setSelectedTenantInspection({});
    }

    const handleDirectorySelection = (directory) => {
        console.log('in parent handleDirectorySelection', directory);
        form.setValues({directory: directory.directory, blobId: directory.id})
        setSelectedDirectory(directory);
    }
    const handleTenantInspectionSelection = (tenantInspection) => {
        console.log('in parent handleTenantInspectionSelection', tenantInspection);
        var inspections = tenantInspection.inspections.join(',');
        form.setValues({tenant: tenantInspection.tenant.id, inspections: inspections});
        setSelectedTenantInspection(tenantInspection);
    }
    const handleCreateProject = async () => {
        console.log(selectedDirectory);
        console.log(selectedTenantInspection);
        var data = {
          projectName: form.values.projectName,
          projectDescription: form.values.projectDescription,
          selectedBlobConfigurationId: form.values.blobId,
          selectedDirectory: form.values.directory,
          selectedTenantId: form.values.tenant,
          selectedInspections: form.values.inspections,
        };
        console.log('posting data', data);  

        if (!form.values.projectName || form.values.inspections.length === 0) {
          console.log('Invalid form data');
          return;
        }
        // post data
        try {                
          const response = await axiosPrivate.post(
            'api/createProject', 
            data, 
            {
              headers: {
                'x-access-token': accessToken
              }
            });
          console.log('successfully posted data', response.data);
          notifications.success(({
            title: 'Success',
            message: `Projct ${response.data.newProjectId} created successfully`,
            color: 'green',
            autoClose: 2000,
          }));
          resetForm();
        } catch (error) {
          notifications.error(({
            title: 'Failed',
            message: `${form.values.projectName} not created: ${error.message}`,
            color: 'red',
            autoClose: 2000
          }));
        }
    }

    // console.log('in parent check', directories);

    return (
      <Stack style={{marginTop: 20, width: '70%', marginLeft: 'auto', marginRight: 'auto'}}>  
        <form onSubmit={form.onSubmit(handleCreateProject)} onReset={() => resetForm()}>
        <TextInput label="Project Name" placeholder="Enter project name" { ...form.getInputProps('projectName') }/>
        <TextInput label="Project Description" placeholder="Enter project description" {...form.getInputProps('projectDescription')} />
        { directories.length > 0 && <SelectDirectoryComponent data={directories} selected={selectedDirectory} onSelection={handleDirectorySelection} /> }
        { selectedDirectory && <SelectTenantNInspection onSelection={handleTenantInspectionSelection} /> }
        <div style={{display: 'flex', justifyContent: 'space-between', marginTop: 20}}>
          <Button type="submit" size="lg" radius="lg" onClick={() => resetForm()}>Reset</Button>
          <Button type="submit" size="lg" radius="lg"onClick={handleCreateProject}>Create</Button>
        </div>
        </form>    
      </Stack>
    )
}

export default CreateProjectPage;